module.exports = __webpack_public_path__ + "img/blue.d3f63572.svg";